import { BackgroundJob } from 'BackgroundJob';
import { JobContextType } from 'JobContext';
import { Article, ArticleStatus } from '../../../models/Article';

const CHAT_ONLY_STATUSES: ArticleStatus[] = ['DRAFT', 'PENDING_GENAI', 'FAILED'];
const SKIP_CONTENT_LOAD_STATUSES: ArticleStatus[] = ['DRAFT', 'PENDING_GENAI', 'FAILED'];

export function getExpandedChatHeight(): number {
  const availableHeight = window.innerHeight - 40;
  return Math.min(350, Math.max(250, availableHeight));
}

export function shouldOnlyShowChat(status: string): boolean {
  return CHAT_ONLY_STATUSES.includes(status.toUpperCase() as ArticleStatus);
}

export function shouldLoadArticleContent(status: string): boolean {
  return !SKIP_CONTENT_LOAD_STATUSES.includes(status.toUpperCase() as ArticleStatus);
}

export function getArticleJobsFromContext(
  articleId: string,
  jobs: JobContextType['jobs'],
): {
  articleJobs: BackgroundJob[];
  isProcessing: boolean;
  currentJobId?: string;
  hasRunningJob: boolean;
} {
  const relevantJobs = jobs?.runningJobs.filter(
    (j: BackgroundJob) =>
      j.linkedModelType === 'Article' &&
      j.linkedModelId === articleId &&
      (j.updatedAt ? new Date(j.updatedAt).getTime() : 0) + 12 * 60 * 60 * 1000 > Date.now(),
  );

  const recentlyCompletedJobs = jobs?.recentlyCompletedJobs.filter(
    (j: BackgroundJob) => j.linkedModelType === 'Article' && j.linkedModelId === articleId,
  );

  const allArticleJobs = [...(relevantJobs || []), ...(recentlyCompletedJobs || [])];
  const latestJob = relevantJobs?.[0];
  const isProcessing = latestJob?.status === 'IN_PROGRESS' || latestJob?.status === 'PENDING';
  const hasRunningJob = Boolean(relevantJobs && relevantJobs.length > 0);

  return {
    articleJobs: allArticleJobs,
    isProcessing: Boolean(isProcessing),
    currentJobId: latestJob?.id,
    hasRunningJob,
  };
}

export function sanitizeArticlePdfFilename(articleLocation: string, articleId: string): string {
  return (articleLocation.split('/').pop() || `article_${articleId}`)
    .replace(/[<>:"/\\|?*\x00-\x1F]/g, '')
    .slice(0, 255);
}
